export enum Permission {
  'EDIT_ANY_ARTICLE' = 'EDIT_ANY_ARTICLE',
  'REMOVE_ANY_ARTICLE' = 'REMOVE_ANY_ARTICLE',
  'EDIT_TAGS_IN_ARTICLE' = 'EDIT_TAGS_IN_ARTICLE',
  'PUBLISH_ARTICLE' = 'PUBLISH_ARTICLE',
  'VIEW_ANY_IMAGE' = 'VIEW_ANY_IMAGE',
}
